import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import switchBtn from "../images/switchLight.png";
import { TYPES } from "./constants";
export const images = {
  switchBtn
};
export default {
  palette: {
    type: TYPES.LIGHT,
    background: {
      opacity: 0.7,
      default: "#fff",
      paper: "rgba(255, 255, 255, 0.85)",
      input: "#fff",
      modal: "#ffffff",
      dialog: "#fff",
      dialogSecondary: "#fff",
      image: "#fff",
      compliment: "rgba(0, 0, 0, 0.2)",
      sheer: "rgba(255, 255, 255, 0.85)",
      rateButton: "rgba(0, 0, 0, 0.1)",
      rateButtonOpacity: 0.4
    },
    text: {
      primary: "#000",
      hint: "#dc0032",
      hintSecondary: "#a6a9ad",
      hintThird: "#595959",
      secondary: "#000000",
      redWhite: "#dc0032",
      redBlue: "#dc0032",
      headline: "rgba(0,0,0, 0.6)",
      subtitle: "#a6a9ad",
      highlightSuccess: "#1ca521",
      placeholder: "rgba(0,0,0, 0.6)",
      responsibility: "#000",
      optionSubtitle: "#dc0032"
    },
    border: {
      default: "#b7b9bd",
      iconBlock: "rgba(0, 0, 0, 0.5)",
      logo: "rgba(238, 238, 238, 0.7)",
      logoOFD: "rgba(26, 29, 33, 0.4)",
      mobileLogoOFD: "#e2e2e2",
      safePlaceInput: "rgba(0, 0, 0, 0.18)"
    },
    icon: {
      default: "#dc0032",
      red: "#dc0032",
      blockIcon: "#000000",
      dark: "#454545",
      neighbourSelected: "#5ba16b",
      vip: "#808285"
    },
    error: {
      secondary: "#dc0032"
    }
  }
};